import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { PackageNames } from '../../../shared/constants/packaging';
import { ITenantInfoWithPackageInfo } from '../../../shared/interfaces/tenant.interface';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class TenantPackageService {
  public readonly tenantPackageChange$: Observable<PackageNames>;

  constructor(private userService: UserService) {
    this.tenantPackageChange$ = this.userService.currentTenant$.pipe(
      map((tenant: ITenantInfoWithPackageInfo): PackageNames => tenant?.packageName as PackageNames),
      distinctUntilChanged(),
    );
  }
}
